"use client"

import type { DateRange } from "react-day-picker"
import { memo, useState } from "react"
import { format } from "date-fns"

import { cn } from "@productlane/lib/src/browser"

import { CalendarIcon } from "../icons/project/calendar-icon"
import { Button } from "./button"
import { Calendar } from "./internal/calendar"
import { Popover } from "./popover"

interface DateRangePickerProps {
	dateRange: DateRange | undefined
	setDateRange: (value: DateRange | undefined) => void
	className?: string
	disabled?: boolean
}

function DateRangePickerInner({
	dateRange,
	setDateRange,
	className,
	disabled,
}: DateRangePickerProps) {
	const [isOpen, setIsOpen] = useState(false)

	return (
		<Popover
			open={isOpen}
			onOpenChange={setIsOpen}
			content={
				<Calendar
					mode="range"
					selected={dateRange}
					onSelect={(value) => {
						setDateRange(value)
						if (value?.from && value?.to) {
							setIsOpen(false)
						}
					}}
					autoFocus
					numberOfMonths={2}
				/>
			}
			className="w-auto bg-white p-0 dark:bg-gray-800"
			align="center"
		>
			<Button
				variant="outline"
				className={cn(
					"w-auto justify-start text-left font-normal",
					!dateRange && "text-secondary",
					disabled && "pointer-events-none",
					className,
				)}
				Icon={CalendarIcon}
				disabled={disabled}
			>
				{dateRange?.from ? (
					dateRange.to ? (
						<>
							{format(dateRange.from, "PP")} - {format(dateRange.to, "PP")}
						</>
					) : (
						format(dateRange.from, "PP")
					)
				) : (
					<span>Pick a date range</span>
				)}
			</Button>
		</Popover>
	)
}

export const DateRangePicker = memo(DateRangePickerInner)
